import Loading from '../../../Common/Loading';
import { useGeneralProductionChartsDataContext } from './hooks/useGeneralProductionChartsDataContext';
import { AnnualEvolutionServices } from './AnnualEvolutionServices';
import { MonthlyEvolutionServices } from './MonthlyEvolutionServices';
import { ServiceByType } from './ServiceByType';
import { ServicesByAge } from './ServicesByAge';
import { ServicesBySex } from './ServicesBySex';

export const Charts = () => {
    const { isLoading } = useGeneralProductionChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <AnnualEvolutionServices />
                <ServiceByType />
            </div>
            <div className="charts-side-by-side-dashboards">
                <ServicesByAge />
                <ServicesBySex />
            </div>
            <div className="w-100">
                <MonthlyEvolutionServices />
            </div>
        </>
    );
};
